module.exports = __webpack_public_path__ + "img/hyun_woong-min.12b471f6.jpg";